import React from 'react';
export function UrgencyBanner() {
  return null;
}